// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase configuration - you'll need to replace these with your actual Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "your-api-key",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "your-project-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "your-project.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "your-app-id",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "your-measurement-id"
};
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging: any = null;

// Check if the browser supports Firebase messaging
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    // Firebase messaging not supported
  }
}

export { messaging };

// Request permission for notifications
export const requestNotificationPermission = async (): Promise<string | null> => {
  if (!messaging) {
    // Firebase messaging not available
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || "your-vapid-key"
      });
      
      if (token) {
        // FCM token obtained
        return token;
      } else {
        // No registration token available
        return null;
      }
    } else {
      // Notification permission denied
      return null;
    }
  } catch (error) {
    // Handle FCM token error
    return null;
  }
};

// Listen for foreground messages
export const onForegroundMessage = (callback: (payload: any) => void) => {
  if (!messaging) {
    // Firebase messaging not available
    return () => {};
  }

  return onMessage(messaging, callback);
};

// Send a test notification directly using browser's Notification API
export const sendTestNotification = async (title: string, options: NotificationOptions = {}) => {
  try {
    // Request permission first
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // Create and show the notification
      const notification = new Notification(title, {
        icon: '/faviconV2.png',
        badge: '/faviconV2.png',
        requireInteraction: true,
        ...options
      });

      // Auto-close after 5 seconds
      setTimeout(() => {
        notification.close();
      }, 5000);

      return notification;
    } else {
      throw new Error('Notification permission denied');
    }
  } catch (error) {
    // Handle test notification error
    throw error;
  }
};

export default app;
